import React from "react"
import CodeMirror from '@uiw/react-codemirror';
import { sql } from '@codemirror/lang-sql';
import CSBaseControl from './CSBaseControl'
import { Button } from "primereact/button";
import { Dialog } from "primereact/dialog";
import { githubLight } from '@uiw/codemirror-theme-github';

class CSSqlTextArea extends CSBaseControl
{
    constructor(props)
    {
        super(props);

        this.cfGetControl       = this.cfGetControl.bind(this);
        this.cfHandleChange     = this.cfHandleChange.bind(this);
        this.cfToggleMaximize   = this.cfToggleMaximize.bind(this);
    }

    cfHandleChange(event)
    {
        if(this.state.mHandleChange)
        {
            let lData = {};
            lData.control_type_ = 'sql_text_area';
            lData.data_field_   = this.state.mDataField;
            lData.value_        = event;
            lData.id_           = this.state.mId;

            this.state.mHandleChange(lData);
            this.setState({mValue : event});
        }
    }

    cfToggleMaximize() {
        this.setState({ mIsMaximized: !this.state.mIsMaximized });
    }

    cfGetControl()
    {
        let lCtl = null;
        let lControl = null;
        let lHeader = null;

        let lPopoutButton = null; 
        if(this.state.mEnablePopout) {
            lPopoutButton = 
                <Button
                    icon      = {this.state.mIsMaximized ? "pi pi-window-minimize" : "pi pi-window-maximize"}
                    className = "p-button-rounded p-button-text"
                    onClick   = {this.cfToggleMaximize}
                    tooltip   = {this.state.mIsMaximized ? "Restore" : "Maximize"}
                />

            lHeader = (
                <div className="cs-sql-header">
                    <div style={{ flex: 1, textAlign: 'center', fontWeight: 'bold', fontSize: '.9rem' }}>
                        {this.props.display_label_}
                    </div>
                    
                    {lPopoutButton}
                </div>
            );
        }

        if(this.state.mControlType && (this.state.mControlType === 'sql_text_area'))
        {
            lCtl = (
                <div className="cs-control field grid">
                    { (!this.state.mIsMaximized) ? lHeader : null }
                    <CodeMirror 
                        style       = {{ 
                            backgroundColor : (this.state.mEditable) ? '#FFFFFF' : 'var(--primary-color)', 
                            whiteSpace      : 'pre-wrap', 
                            width           : '100%' }}

                        basicSetup  = {{ lineWrapping: true }}                        
                        height      = { (!this.state.mIsMaximized) ? this.state.mHeight : null }
                        extensions  = {[sql()]}
                        className   = "cs-text-area"
                        id          = { this.state.mId } 
                        name        = { this.state.mDataField }
                        value       = { this.state.mValue || '' }
                        onChange    = { this.cfHandleChange }
                        readOnly    = { !this.state.mEditable }
                        theme       = { githubLight }
                        />
                </div>
            )

            lControl= (!this.state.mIsMaximized) ? lCtl :
                <Dialog visible         = {true}
                        modal           = {true}
                        closable        = {false}
                        dismissableMask = {false}                        
                        style           = {{minWidth : '800px'}}
                        header          = {lHeader}
                        appendTo        = { document.body }>
                    { lCtl }
                </Dialog>
        }

        return lControl;
    }

    render()
    {
        return this.cfGetControl();
    }
}

export default CSSqlTextArea;
